import { useCallback, useContext } from 'react';
import axios from 'axios';
import { yieldToMainAsync } from '@wix/da-hooks/pkg/yieldToMain';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { useWixDealerListener } from './DealerAdIframe';
import ddt from '@wix/da-ddt';

export function useCloseTracking(
  passedOffer: any,
  realEstateId: string,
  options: {
    onCloseStart?: () => Promise<void>;
    onCloseEnd?: () => Promise<void>;
    iframeCommandHandler?: (command: string, data: any) => void;
  } = {}
) {
  const { biClientIdSigned, biClientId, useridUuid } =
    useContext(SessionContext);

  const { onCloseStart, onCloseEnd, iframeCommandHandler } = options;

  const closeHandler = useCallback(async () => {
    if (onCloseStart) {
      await onCloseStart();
    }
    await yieldToMainAsync();
    const userId = useridUuid === '' ? biClientId : useridUuid;
    const params = {
      realEstateId,
      offerId: passedOffer.offerGuid,
      userId: userId,
      targetAccountId: userId,
      loggedInAccountId: userId,
    };
    if (passedOffer) {
      // https://bo.wix.com/wix-docs/rest/internal-tools/dealer-offer-events/report-event
      axios
        .create()
        .post(
          `https://www.wix.com/_api/dealer-offer-events-service/proxy/v1/dealer-offer-events/${passedOffer?.offerGuid}`,
          {
            deviantArtUserId: biClientIdSigned,
            event: {
              type: 'CLOSE',
              ...params,
            },
          },
          {
            headers: {},
          }
        )
        .catch(e => {});
      // https://bo.wix.com/wix-docs/rest/internal-tools/dealer-offer-events/report-event
      axios
        .create()
        .post(
          `https://www.wix.com/_api/dealer-offer-events-service/proxy/v1/dealer-offer-events/${passedOffer?.offerGuid}`,
          {
            deviantArtUserId: biClientIdSigned,
            event: {
              type: 'SHOW_LATER',
              ...params,
            },
          },
          {
            headers: {},
          }
        )
        .catch(e => {});
    }
    if (onCloseEnd) {
      await onCloseEnd();
    }
  }, [
    biClientIdSigned,
    passedOffer,
    realEstateId,
    useridUuid,
    biClientId,
    onCloseStart,
    onCloseEnd,
  ]);

  const handler = useCallback(
    data => {
      ddt.log('dealer', 'Got command from iframe2', data);
      if (iframeCommandHandler) {
        iframeCommandHandler(data.command, data.data);
      }
    },
    [iframeCommandHandler]
  );

  useWixDealerListener(realEstateId, handler);

  return closeHandler;
}
